import * as angular from 'angular';

angular.module('GorillaBoy.common')
.controller('lockAndEditController', [
    '$scope',
    '$log',
    'doc',
    'lockFile',
    'editWithCompanion',
    function lockAndEditController($scope, $log, doc, lockFile, editWithCompanion) {
        $scope.isDocumentCheckedOut = function(doc) {
            return !!(doc.CheckoutInfo);
        };

        $scope.editWithoutChangingLock = function() {
            editWithCompanion(doc);
            $log.debug('edit without changing lock. The document Id: ' + doc.Id);
            $scope.$dismiss();
        };

        $scope.editWithLock = function() {
            if (!$scope.isDocumentCheckedOut(doc)) {
                $log.debug('edit with lock: document is not previously locked');
                lockFile(doc).then(function() {
                    editWithCompanion(doc);
                    $log.debug('lock file and edit. The document Id: ' + doc.Id);
                }, function() {
                    $log.error('lock failed when try to lock and edit');
                }).finally($scope.$dismiss);
            } else {
                $log.debug('edit with lock: document is previously locked');
                $scope.editWithoutChangingLock();
            }
        };
    }
]);